import { createHash } from "node:crypto";

function normalizeToUint8Array(content: Buffer | Uint8Array): Uint8Array {
  return new Uint8Array(content.buffer, content.byteOffset, content.byteLength);
}

/**
 * Generates a deterministic SHA-256 hash (hex) for the provided file content.
 */
export function hashFileContent(content: Buffer | Uint8Array): string {
  return createHash("sha256").update(normalizeToUint8Array(content)).digest("hex");
}

/**
 * Base64-encoded SHA-256 of the file content, for FHIR `Attachment.hash`.
 * (FHIR's field comment references SHA-1, but the type is `base64Binary` and doesn't constrain the
 * algorithm — we use SHA-256 for consistency with `hashFileContent` and stronger collision resistance.)
 */
export function hashFileContentBase64(content: Buffer | Uint8Array): string {
  return createHash("sha256").update(normalizeToUint8Array(content)).digest("base64");
}
